<div class="p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Histórico de Estoque</h1>

  <p-table [value]="historicos" class="w-full mt-6">
    <ng-template pTemplate="header">
      <tr>
        <th class="p-2 border-b text-left">Id</th>
        <th class="p-2 border-b text-left">Produto</th>
        <th class="p-2 border-b text-left">Qtd</th>
        <th class="p-2 border-b text-left">Operação</th>
        <th class="p-2 border-b text-left">Usuário</th>
        <th class="p-2 border-b text-left">Saldo Anterior</th>
        <th class="p-2 border-b text-left">Saldo Atual</th>
        <th class="p-2 border-b text-left">Data</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-estoque>
      <tr>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.id }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.codigoProduto }} - {{ estoque.nomeProduto }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.quantidade }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.operacao }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.usuario.username }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.saldoAnterior | number:'1.3-3' }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.saldoAtual | number:'1.3-3' }}
        </td>
        <td class="p-2 border-b" [ngClass]="{'bg-green': isAdicionado(estoque.operacao), 'bg-red': !isAdicionado(estoque.operacao)}">
          {{ estoque.dataUltimaModificacao | date: 'dd/MM/yyyy HH:mm:ss' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
